import {
  orchestrationInfo,
  customerAccessTransfer,
} from "src/api/smartChargingClients";
import {
  OrchestrationInfo,
  EvseSelfOnboardingDetails,
} from "src/models/smartChargingClientsModels";
import { ROUTES } from "src/consts/routes";
import { useEffect, useCallback } from "react";
import { CircularProgress, Stack } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { SMART_CHARGING_ROUTES } from "src/consts/Routes/SmartCharging";
import { MicroFrontendDetails, SESSION_KEYS } from "src/consts/session";

enum OrchestrationFrontendFlow {
  EVSE_OVERVIEW = "evseOverview",
  COMP_CHECK = "compCheck",
  EVSE_ONBOARDING = "evseOnboarding",
}

const SmartChargingStart = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const transferId = searchParams.get("tid") || "";

  const [, setTransferId] = useSessionStorage<string>(SESSION_KEYS.TRANSFER_ID);
  const [getCustomerAccess, setCustomerAccess] = useSessionStorage<string>(
    SESSION_KEYS.MFE_CUSTOMER_ACCESS,
  );
  const [, setMicroFrontendDetails] = useSessionStorage<MicroFrontendDetails>(
    SESSION_KEYS.MICRO_FRONTEND_DETAILS,
  );
  const [, setEvseSelfOnboardingData] =
    useSessionStorage<EvseSelfOnboardingDetails>(
      SESSION_KEYS.EVSE_SELF_ONBOARDING_DETAILS,
    );
  const [, setOrchestrationInfo] = useSessionStorage<OrchestrationInfo>(
    SESSION_KEYS.ORCHESTRATION_INFO,
  );

  const getCustomerAccessTransfer = useCallback(async () => {
    try {
      const sessionTransferId = getCustomerAccess();

      if (sessionTransferId) {
        const orchestrationInfoResponse = await orchestrationInfo({
          xIsonCustomerToken: sessionTransferId,
        });
        setOrchestrationInfo(orchestrationInfoResponse);

        if (
          orchestrationInfoResponse.provisionedEvses &&
          orchestrationInfoResponse.provisionedEvses.length > 0
        ) {
          setEvseSelfOnboardingData(
            orchestrationInfoResponse.provisionedEvses[0],
          );
        }

        if (
          orchestrationInfoResponse.frontendFlow ===
          OrchestrationFrontendFlow.COMP_CHECK
        ) {
          navigate(`${SMART_CHARGING_ROUTES.COMPATIBILITY}`);
        }
        if (
          orchestrationInfoResponse.frontendFlow ===
          OrchestrationFrontendFlow.EVSE_ONBOARDING
        ) {
          navigate(`${SMART_CHARGING_ROUTES.ADD_WALLBOX_START}`);
        }
        if (
          orchestrationInfoResponse.frontendFlow ===
          OrchestrationFrontendFlow.EVSE_OVERVIEW
        ) {
          navigate(`${SMART_CHARGING_ROUTES.OVERVIEW_START}`);
        }
        return;
      }

      const response = await customerAccessTransfer({
        payload: {
          tid: transferId,
        },
      });

      setTransferId(transferId);
      setCustomerAccess(response.access);
      setMicroFrontendDetails(response.microFrontendDetails);

      const orchestrationInfoResponse = await orchestrationInfo({
        xIsonCustomerToken: response.access,
      });
      setOrchestrationInfo(orchestrationInfoResponse);

      if (
        orchestrationInfoResponse.provisionedEvses &&
        orchestrationInfoResponse.provisionedEvses.length > 0
      ) {
        setEvseSelfOnboardingData(
          orchestrationInfoResponse.provisionedEvses[0],
        );
      }

      if (
        orchestrationInfoResponse.frontendFlow ===
        OrchestrationFrontendFlow.COMP_CHECK
      ) {
        navigate(`${SMART_CHARGING_ROUTES.COMPATIBILITY}`);
      }
      if (
        orchestrationInfoResponse.frontendFlow ===
        OrchestrationFrontendFlow.EVSE_ONBOARDING
      ) {
        navigate(`${SMART_CHARGING_ROUTES.ADD_WALLBOX_START}`);
      }
      if (
        orchestrationInfoResponse.frontendFlow ===
        OrchestrationFrontendFlow.EVSE_OVERVIEW
      ) {
        navigate(`${SMART_CHARGING_ROUTES.OVERVIEW_START}`);
      }
    } catch (e) {
      navigate(
        `${ROUTES.ERROR}?msgId=smart_charging_onboarding_transfer_error`,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getCustomerAccessTransfer();
  }, [getCustomerAccessTransfer]);

  return (
    <>
      <Stack
        pl={{ sm: "116px" }}
        mt={{ xs: "100px", sm: "0px" }}
        alignItems={{ xs: "center", sm: "start" }}
      >
        <CircularProgress sx={{ color: "gray" }} />
      </Stack>
    </>
  );
};

export default SmartChargingStart;
